import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import brandPortalCustomers from "@faire/web-api/routes/brand-portal/customers";
import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { path as getSelfServeRecommendedArticleRoute } from "@faire/web-api/routes/support/self-serve/recommended-article";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var QuestionAboutCustomerIA = function QuestionAboutCustomerIA(_ref) {
  var _selectedBrandOrder$b, _selectedBrandOrder$b2, _selectedBrandOrder$r;
  var context = _ref.context;
  var selectedBrandOrder = context.brandOrder;
  var brandOrderToken = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b === void 0 ? void 0 : _selectedBrandOrder$b.token;
  var brandName = (_selectedBrandOrder$b2 = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.brand_name) !== null && _selectedBrandOrder$b2 !== void 0 ? _selectedBrandOrder$b2 : "brand";
  var retailerName = (_selectedBrandOrder$r = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : selectedBrandOrder.retailer_name) !== null && _selectedBrandOrder$r !== void 0 ? _selectedBrandOrder$r : "retailer";
  var conversationName = isBrand() ? retailerName : brandName;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "T44xRB",
      defaultMessage: [{
        "type": 0,
        "value": "For more information about a customer that has placed an order, you can go to the "
      }, {
        "children": [{
          "type": 0,
          "value": "Order details page"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": ". This page will show the retailer’s name, phone number and address. For additional details, you can click on the retailer’s name to go to the retailer’s page in your "
      }, {
        "children": [{
          "type": 0,
          "value": "Customers"
        }],
        "type": 8,
        "value": "CustomerLinkFormatting"
      }, {
        "type": 0,
        "value": " tab. The customer detail page will include:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        },
        CustomerLinkFormatting: function CustomerLinkFormatting(chunks) {
          return customersLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "H0tQBp",
      defaultMessage: [{
        "type": 0,
        "value": "Past orders"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "PQSolo",
      defaultMessage: [{
        "type": 0,
        "value": "Total order volume"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "rFfKGc",
      defaultMessage: [{
        "type": 0,
        "value": "Type of relationship"
      }]
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Yl6Vqu",
      defaultMessage: [{
        "type": 0,
        "value": "More information, including when the retailer joined Faire"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gPsfr6",
      defaultMessage: [{
        "type": 0,
        "value": "You can also message the retailer directly from their customer page by clicking the "
      }, {
        "children": [{
          "type": 0,
          "value": "Message "
        }, {
          "type": 1,
          "value": "conversationCompanyName"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " button, if you’d like to ask them a question."
      }],
      values: {
        conversationCompanyName: conversationName,
        LinkFormatting: function LinkFormatting(chunks) {
          return messageLinkFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4b7lCJ",
      defaultMessage: [{
        "type": 0,
        "value": "For more information about a customer that has placed an order, you can go to your "
      }, {
        "children": [{
          "type": 0,
          "value": "Orders"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " and navigate to a specific order. The Order details page will show the retailer’s name, phone number and address. For additional details, you can click on the retailer’s name to go to the retailer’s page in your "
      }, {
        "children": [{
          "type": 0,
          "value": "Customers"
        }],
        "type": 8,
        "value": "CustomerLinkFormatting"
      }, {
        "type": 0,
        "value": " tab. The customer detail page will include:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        },
        CustomerLinkFormatting: function CustomerLinkFormatting(chunks) {
          return customersLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "H0tQBp",
      defaultMessage: [{
        "type": 0,
        "value": "Past orders"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "PQSolo",
      defaultMessage: [{
        "type": 0,
        "value": "Total order volume"
      }]
    }))), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "rFfKGc",
      defaultMessage: [{
        "type": 0,
        "value": "Type of relationship"
      }]
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Yl6Vqu",
      defaultMessage: [{
        "type": 0,
        "value": "More information, including when the retailer joined Faire"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gPsfr6",
      defaultMessage: [{
        "type": 0,
        "value": "You can also message the retailer directly from their customer page by clicking the "
      }, {
        "children": [{
          "type": 0,
          "value": "Message "
        }, {
          "type": 1,
          "value": "conversationCompanyName"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " button, if you’d like to ask them a question."
      }],
      values: {
        conversationCompanyName: conversationName,
        LinkFormatting: function LinkFormatting(chunks) {
          return messageLinkFormatting(chunks);
        }
      }
    })));
  }
};
var messageLinkFormatting = function messageLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: getSelfServeRecommendedArticleRoute({
      message_modal: "1"
    })
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var orderDetailsLinkFormatting = function orderDetailsLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var customersLinkFormatting = function customersLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalCustomers(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var isBrand = function isBrand() {
  var retailerToken = getRetailerToken();
  if (retailerToken) {
    return false;
  }
  return true;
};